<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="Ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_Ack" title="Link target outside of Sample"><span class="ePub-B">Acknowledgments</span></span></p>
<p class="FMTNI">I greatly appreciate the expertise, support, and encouragement that our sources, readers, friends, and family have given us over the years. Because of you, our stories will continue.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?c4a96f66